import Backbone from 'backbone';
import ArchiveDate from 'models/newsroom/archiveDate';

class ArchiveDates extends Backbone.Collection {
}

ArchiveDates.prototype.model = ArchiveDate;

export default ArchiveDates;
